import { render } from "./VersionsList.vue?vue&type=template&id=448aa75e"
import script from "./VersionsList.vue?vue&type=script&lang=js"
export * from "./VersionsList.vue?vue&type=script&lang=js"

import "./VersionsList.vue?vue&type=style&index=0&id=448aa75e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__